'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _vstui = require('@vitalsource/vstui');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var QuestionCircleFill = function (_PureComponent) {
  function QuestionCircleFill() {
    return _classCallCheck(this, QuestionCircleFill), _possibleConstructorReturn(this, (QuestionCircleFill.__proto__ || Object.getPrototypeOf(QuestionCircleFill)).apply(this, arguments));
  }

  return _inherits(QuestionCircleFill, _PureComponent), _createClass(QuestionCircleFill, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_vstui.Icon, _extends({}, this.props, {
        height: 18,
        width: 18
      }), _react2.default.createElement('path', {
        d: 'M11.773 7.717c-.171.339-.47.714-.896 1.126l-.543.519a1.84 1.84 0 0 0-.585 1.15l-.027.41h-1.72c0-.628.076-1.128.228-1.5.152-.373.432-.74.838-1.1.405-.361.675-.655.809-.881.134-.226.201-.466.201-.717 0-.758-.348-1.138-1.047-1.138-.332 0-.598.102-.796.307-.2.204-.304.486-.313.845h-1.95c.01-.856.285-1.527.83-2.011C7.348 4.242 8.09 4 9.032 4c.95 0 1.685.23 2.21.69.524.46.787 1.109.787 1.947 0 .382-.085.74-.255 1.08m-2.088 5.995c-.199.192-.463.288-.79.288-.326 0-.59-.096-.788-.288a.972.972 0 0 1-.3-.73c0-.3.103-.545.306-.741.204-.193.466-.291.783-.291s.579.098.782.29a.983.983 0 0 1 .306.742.97.97 0 0 1-.299.73M9.002 0a9 9 0 0 0-9 9 9 9 0 1 0 9-9'
      }));
    }
  }]), QuestionCircleFill;
}(_react.PureComponent);

QuestionCircleFill.displayName = 'QuestionCircleFill', QuestionCircleFill.vstuiName = 'Icon', exports.default = QuestionCircleFill;